import angular from 'angular';
import uiRouter from 'angular-ui-router';
import loansDetailBasicCharacteristicsComponent from './loansDetailBasicCharacteristics.component';

let loansDetailBasicCharacteristicsModule = angular.module('loansDetailBasicCharacteristics', [
  uiRouter
])

.component('loansDetailBasicCharacteristics', loansDetailBasicCharacteristicsComponent)

.name;

export default loansDetailBasicCharacteristicsModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansDetail/loansDetailBasicCharacteristics/loansDetailBasicCharacteristics.js